<template>
  <v-dialog
    v-model="dialog"
    max-width="310"
    persistent
    light
  >
    <v-card>
      <v-card-title class="headline">
        Export to Google Drive
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        This will export this file into a google drive file. <br>
        This url will be sended for your e-mail. <br><br>

        This may take a while...
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          small
          @click.native="closeOnClickOutside"
        >
          Annuler
        </v-btn>

        <v-btn
          color="info"
          small
          @click.native="exportToDrive"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';

import { useStore } from 'vue2-helpers/vuex';
import { getGraphqlSchema } from '../../graphql/index';
import { EventBus } from '../../mixins';

const dialog = ref(false);

const item = ref(null);

const open = newItem => {
  // Disables scroll on the page
  document.documentElement.style.overflow = 'hidden';

  // Opens dialog box
  dialog.value = true;

  // Set's the directory where the folder will be created
  item.value = newItem;
};

// eslint-disable-next-line no-undef
defineExpose({ open });

const close = () => {
  document.documentElement.style.overflow = 'auto';
  dialog.value = false;
};

const closeOnClickOutside = () => {
  if (dialog.value) {
    EventBus.$emit('unselectItem');
    close();
  }
};

const callQuery = ref(false);

const exportToDrive = () => {
  closeOnClickOutside();

  callQuery.value = true;
};

const store = useStore();

const { onResult, onError } = useQuery(
  // TODO: add currect query
  getGraphqlSchema('exportDrive'),
  item,
  { enabled: callQuery, fetchPolicy: 'no-cache' }
);

onResult(r => {
  if (r.loading) {
    return;
  }

  // Cancel query after one execution
  callQuery.value = false;

  const options = {
    timeout: 5000,
    type: 'info'
  };

  const text = 'The export start. This may take a while...';

  // Show notification
  EventBus.$emit('show-notification', { text, options });

  close();
});

onError(() => {
  const options = {
    timeout: 5000,
    type: 'error'
  };

  callQuery.value = false;

  const text = 'Something wrong with export service...';

  EventBus.$emit('show-notification', { text, options });

  close();
});
</script>

<style>

</style>
